import schema from './schema';
import { buildASTSchema } from 'graphql/utilities';

export const astSchema = buildASTSchema(schema, {
  assumeValidSDL: true,
});
